<p-drawer
  [(visible)]="visible"
  position="right"
  styleClass="efetivo-drawer-dark"
  [modal]="true"
  [closable]="true"
  header="Editar Efetivo"
  (onHide)="closeDrawer()"
>
  <div class="modal-body">
    <!-- skeleton enquanto carrega o efetivo da API -->
    <div *ngIf="loadingEfetivo" class="drawer-skeleton">
      <p-skeleton height="96px" width="96px" shape="circle" />
      <p-skeleton height="1.4rem" width="55%" />
      <p-skeleton height="1rem" width="35%" />
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
    </div>

    <div class="form-sections" *ngIf="!loadingEfetivo" [formGroup]="form">
      <!-- DADOS PESSOAIS -->
      <div class="form-section">
        <h4 class="form-section-title">
          <i class="fas fa-user"></i> Dados Pessoais
        </h4>

        <!-- FOTO -->
        <div class="foto-section">
          <div class="foto-wrap">
            <div class="foto-circle" (click)="fotoInput.click()">
              <img
                *ngIf="fotoPreviewUrl"
                [src]="fotoPreviewUrl"
                alt="Foto"
                class="foto-img"
              />
              <div *ngIf="!fotoPreviewUrl" class="foto-placeholder">
                <i class="fas fa-camera"></i>
                <span>Foto</span>
              </div>
              <div class="foto-overlay"><i class="fas fa-pencil-alt"></i></div>
            </div>
            <input
              #fotoInput
              type="file"
              accept="image/jpeg,image/png,image/webp"
              hidden
              (change)="onFotoSelect($event)"
            />
          </div>
          <div class="foto-info">
            <p class="foto-hint">Fotografia do colaborador</p>
            <div class="foto-actions">
              <button
                type="button"
                class="btn-web-secondary"
                (click)="fotoInput.click()"
              >
                <i class="fas fa-upload"></i>
                {{ selectedFoto ? "Alterar foto" : "Selecionar foto" }}
              </button>
              <button
                type="button"
                class="btn-web-secondary"
                (click)="openCamera()"
              >
                <i class="fas fa-video"></i> Usar Câmara
              </button>
              <button
                type="button"
                class="btn-web-danger"
                *ngIf="selectedFoto"
                (click)="removeFoto()"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
            <small *ngIf="selectedFoto" class="foto-selected-name">
              <i class="fas fa-check-circle" style="color: var(--green)"></i>
              {{ selectedFoto.name }}
            </small>
            <small *ngIf="!selectedFoto" class="foto-meta"
              >JPG, PNG, WEBP · Máx. 5 MB · Opcional</small
            >
          </div>
        </div>

        <!-- CÂMARA OVERLAY -->
        <div class="camera-overlay" *ngIf="cameraOpen" (click)="closeCamera()">
          <div class="camera-modal" (click)="$event.stopPropagation()">
            <div class="camera-modal-header">
              <span>Tirar Fotografia</span>
              <button
                type="button"
                class="btn-close-camera"
                (click)="closeCamera()"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div class="camera-body">
              <div class="camera-viewfinder" *ngIf="!capturedPhotoUrl">
                <video
                  #cameraVideo
                  class="camera-video"
                  autoplay
                  playsinline
                  muted
                ></video>
                <div class="camera-guide-ring"></div>
              </div>
              <div class="camera-preview" *ngIf="capturedPhotoUrl">
                <img
                  [src]="capturedPhotoUrl"
                  class="camera-preview-img"
                  alt="Prévia"
                />
              </div>
            </div>
            <div class="camera-actions">
              <ng-container *ngIf="!capturedPhotoUrl">
                <button
                  type="button"
                  class="btn-capture"
                  (click)="capturePhoto()"
                >
                  <i class="fas fa-camera"></i>
                </button>
              </ng-container>
              <ng-container *ngIf="capturedPhotoUrl">
                <button
                  type="button"
                  class="btn-web-secondary"
                  (click)="retakePhoto()"
                >
                  <i class="fas fa-sync-alt"></i> Repetir
                </button>
                <button
                  type="button"
                  class="btn-primary-cam"
                  (click)="confirmPhoto()"
                >
                  <i class="fas fa-check"></i> Usar esta foto
                </button>
              </ng-container>
            </div>
            <canvas #cameraCanvas style="display: none"></canvas>
          </div>
        </div>

        <div class="form-grid-2">
          <div class="form-group">
            <label>Nome Completo *</label>
            <input
              pInputText
              type="text"
              formControlName="nome"
              placeholder="Ex: João Manuel da Silva"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label>Nº BI *</label>
            <input
              pInputText
              type="text"
              formControlName="numBI"
              placeholder="000000000LA000"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label>Data Nascimento *</label>
            <p-datePicker
              formControlName="dataNascimento"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              styleClass="form-input" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
            ></p-datePicker>
          </div>
          <div class="form-group">
            <label>Género *</label>
            <p-select
              formControlName="genero"
              [options]="generos"
              optionLabel="label"
              optionValue="value"
              placeholder="Selecione o género"
              styleClass="form-input"
            ></p-select>
          </div>
          <div class="form-group">
            <label>Telefone *</label>
            <div class="phone-input">
              <span>+244</span>
              <p-inputMask
                formControlName="numTelefone"
                mask="999 999 999"
                [unmask]="true"
                placeholder="923 000 000"
                styleClass="form-input no-left-border"
              ></p-inputMask>
            </div>
            <small
              class="sp-error"
              *ngIf="
                form.get('numTelefone')?.invalid &&
                (form.get('numTelefone')?.dirty ||
                  form.get('numTelefone')?.touched)
              "
            >
              Introduza exatamente 9 dígitos.
            </small>
          </div>
          <div class="form-group">
            <label>Email</label>
            <input
              pInputText
              type="email"
              formControlName="email"
              placeholder="joao@email.com"
              class="form-input"
            />
          </div>
          <div class="form-group full">
            <label>Morada</label>
            <input
              pInputText
              type="text"
              formControlName="modara"
              placeholder="Rua, Bairro, Município"
              class="form-input"
            />
          </div>
        </div>
      </div>

      <!-- DADOS PROFISSIONAIS -->
      <div class="form-section">
        <h4 class="form-section-title">
          <i class="fas fa-briefcase"></i> Dados Profissionais
        </h4>
        <div class="form-grid-2">
          <div class="form-group">
            <label>Função *</label>
            <p-select
              formControlName="idFuncao"
              [options]="funcoes"
              optionLabel="nome"
              optionValue="id"
              placeholder="Selecione a função"
              styleClass="form-input"
            ></p-select>
          </div>
          <div class="form-group">
            <label>Categoria *</label>
            <p-select
              formControlName="idCategoria"
              [options]="categorias"
              optionLabel="nome"
              optionValue="id"
              placeholder="Selecione a categoria"
              styleClass="form-input"
            ></p-select>
          </div>
          <div class="form-group">
            <label>Estado</label>
            <p-select
              formControlName="estado"
              [options]="estados"
              optionLabel="label"
              optionValue="value"
              placeholder="Estado do efetivo"
              styleClass="form-input"
            ></p-select>
          </div>
          <div class="form-group">
            <label>Data Admissão *</label>
            <p-datePicker
              formControlName="dataAdmissao"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              styleClass="form-input" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
            ></p-datePicker>
          </div>
          <div class="form-group">
            <label>MEC</label>
            <input
              pInputText
              type="text"
              formControlName="codigoMec"
              placeholder="Ex: MEC-00123"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label>Salário (AOA)</label>
            <p-inputNumber
              formControlName="salario"
              mode="currency"
              currency="AOA"
              locale="pt-AO"
              [min]="0"
              styleClass="form-input"
            ></p-inputNumber>
          </div>
          <div class="form-group full">
            <div class="form-grid-banco">
              <div class="form-group">
                <label>Banco</label>
                <p-select
                  formControlName="banco"
                  [options]="angolanBanks"
                  optionValue="value"
                  optionLabel="label"
                  [showClear]="true"
                  [filter]="true"
                  placeholder="Selecione o banco"
                  styleClass="form-input"
                  (onChange)="onBancoChange($event)"
                >
                </p-select>
              </div>
              <div class="form-group">
                <label>IBAN</label>
                <p-inputMask
                  formControlName="iban"
                  [mask]="ibanMask"
                  placeholder="Selecione o banco primeiro"
                  styleClass="form-input iban-input"
                ></p-inputMask>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CONTACTO DE EMERGÊNCIA -->
      <div class="form-section">
        <h4 class="form-section-title">
          <i class="fas fa-phone"></i> Contacto de Emergência
        </h4>
        <div class="form-grid-2">
          <div class="form-group">
            <label>Nome</label>
            <input
              pInputText
              type="text"
              formControlName="nomeContactoEmergencia"
              placeholder="Nome do familiar"
              class="form-input"
            />
            <small
              class="sp-error"
              *ngIf="
                form.get('nomeContactoEmergencia')?.hasError('required') &&
                (form.get('nomeContactoEmergencia')?.dirty ||
                  form.get('nomeContactoEmergencia')?.touched)
              "
            >
              O nome do contacto é obrigatório.
            </small>
            <small
              class="sp-error"
              *ngIf="
                form.get('nomeContactoEmergencia')?.hasError('minlength') &&
                (form.get('nomeContactoEmergencia')?.dirty ||
                  form.get('nomeContactoEmergencia')?.touched)
              "
            >
              O nome deve ter pelo menos 3 caracteres.
            </small>
            <small
              class="sp-error"
              *ngIf="
                form.get('nomeContactoEmergencia')?.hasError('pattern') &&
                (form.get('nomeContactoEmergencia')?.dirty ||
                  form.get('nomeContactoEmergencia')?.touched)
              "
            >
              O nome deve conter apenas letras e espaços.
            </small>
          </div>
          <div class="form-group">
            <label>Parentesco</label>
            <p-select
              formControlName="parentescoContactoEmergencia"
              [options]="parentescos"
              optionLabel="label"
              optionValue="value"
              placeholder="Selecione"
              styleClass="form-input"
            ></p-select>
          </div>
          <div class="form-group">
            <label>Telefone</label>
            <div class="phone-input">
              <span>+244</span>
              <p-inputMask
                formControlName="numTelContactoEmergencia"
                mask="999 999 999"
                [unmask]="true"
                placeholder="923 000 000"
                styleClass="form-input no-left-border"
              ></p-inputMask>
            </div>
            <small
              class="sp-error"
              *ngIf="
                form.get('numTelContactoEmergencia')?.invalid &&
                (form.get('numTelContactoEmergencia')?.dirty ||
                  form.get('numTelContactoEmergencia')?.touched)
              "
            >
              Introduza exatamente 9 dígitos.
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- ACÇÕES -->
    <div class="modal-actions" *ngIf="!loadingEfetivo">
      <button type="button" class="btn-web-secondary" (click)="closeDrawer()">
        Cancelar
      </button>
      <button class="btn-web-primary" (click)="onSubmit()" [disabled]="loading">
        <i [class]="loading ? 'fas fa-spinner fa-spin' : 'fas fa-check'"></i>
        {{ loading ? "A guardar..." : "Actualizar Efetivo" }}
      </button>
    </div>
  </div>
</p-drawer>
